<script>
    import Vue from 'vue';
    import eventProxyMixin from "./Mixins/eventProxy";
    
    export default {
        name: 'drag-and-drop-endpoint',
        mixins: [eventProxyMixin],
        mounted() {
            const vm = this;
            
            vm.processEndpoints();
        },
        render(createElement, context) {
            //https://css-tricks.com/building-renderless-vue-components/
            return this.$slots.default;
        },
        beforeDestroy() {
            const vm = this;
            const jsPlumbInstance = vm.jsPlumbInstance;
            const endpoints = Object.values(vm.managedEndpoints);
            
            jsPlumbInstance.batch(() => {
                endpoints.forEach(endpoint => jsPlumbInstance.deleteEndpoint(endpoint));
            });
        },
        methods: {
            processEndpoints() {
                const vm = this;
                const jsPlumbInstance = vm.jsPlumbInstance;

                const endpointParameters = vm.endpointParametersArray;
                const endpointIds = endpointParameters.map(e => e.uuid);
                const managedEndpointIds = Object.keys(vm.managedEndpoints);
                
                const newEndpointParameters = endpointParameters.filter(e => managedEndpointIds.indexOf(e.uuid) === -1);
                const removedEndpoints = managedEndpointIds
                    .filter(eId => endpointIds.indexOf(eId) === -1)
                    .map(eId => vm.managedEndpoints[eId]);

                jsPlumbInstance.batch(() => {
                    newEndpointParameters.forEach(endpointParameters => vm.createEndpoint(endpointParameters));
                    removedEndpoints.forEach(endpoint => {
                        Vue.delete(vm.managedEndpoints, endpoint.getUuid());
                        jsPlumbInstance.deleteEndpoint(endpoint);
                    });
                });

                this.$emit('endpoints-updated', {
                    created: newEndpointParameters.length,
                    removed: removedEndpoints.length
                });
            },
            createEndpoint(endpointParameters){
                const vm = this;
                const el = vm.$el;
                const jsPlumbInstance = vm.jsPlumbInstance;
                
                const endpoint = jsPlumbInstance.addEndpoint(
                    el,
                    endpointParameters,
                    vm.referenceParameters
                );

                const createEventProxy = (eventName) => {
                    //jsPlumb does not seem to fire mousedown/mouseup events for source endpoints
                    //thus we need to fire those manually
                    if(endpoint.isSource && (eventName === 'mousedown' || eventName === 'mouseup')){
                        //TODO: Fix onmouseup
                        //onmouseup is not triggered once the user has started dragging
                        //this due to new elements spawning without the given event handler attached
                        
                        //onmousedown/onmouseup
                        endpoint.canvas.addEventListener(eventName, evt => {
                            //Based on docs at: https://community.jsplumbtoolkit.com/doc/events.html (Endpoint Events)
                            vm.$emit(eventName, endpoint, evt);
                        });
                    }
                    else{
                        endpoint.bind(eventName, vm.createEventProxy(eventName));   
                    }
                };
                
                createEventProxy("click");
                createEventProxy("dblclick");
                createEventProxy("contextmenu");
                createEventProxy("mouseover");
                createEventProxy("mouseout");
                createEventProxy("mousedown");
                createEventProxy("mouseup");
                createEventProxy("maxConnections");
                
                vm.managedEndpoints[endpointParameters.uuid] = endpoint;
                
                vm.$emit('endpoint-created', endpoint);
            }
        },
        watch: {
            endpointParametersArray(newEndpoints, oldEndpoints){
                //When the amount of endpoints changed, we need to do a complete re-process
                if(newEndpoints.length !== oldEndpoints.length){
                    this.processEndpoints();
                    return;
                }
                
                //Check if an endpoint was added/removed
                const hasChangedEndpoints = newEndpoints.some(
                    newEndpoint => !oldEndpoints.find(oldEndpoint => oldEndpoint.uuid === newEndpoint.uuid)
                );
                
                if(hasChangedEndpoints){
                    this.processEndpoints();
                }
            }
        },
        computed: {
            endpointParametersArray() {
                const endpointParameters = this.endpointParameters;
                
                return Array.isArray(endpointParameters) ? endpointParameters : [endpointParameters];
            }
        },
        data: () => ({
            managedEndpoints: {}
        }),
        props: {
            jsPlumbInstance: {
                type: Object,
                required: true
            },
            referenceParameters: {
                type: Object,
                required: false,
                default: () => ({})
            },
            endpointParameters: {
                //Object/Array containing specific configurations, base option lookup will take place via 'configurationName' property
                type: Array | Object,
                required: true,
                validate: (e) => {
                    const arr = Array.isArray(e) ? e : [e];

                    //Each object is expected to have an uuid
                    //the uuid property will be used for lookup
                    return arr.reduce((valid, cur) => valid && cur.hasOwnProperty('uuid'), true);
                }
            }
        }
    }
</script>